
import * as z from "zod";

/**
 * Helper to check if an email is from a free email provider
 */
export const isNonFreeEmail = (email: string): boolean => {
  const freeDomains = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
    'icloud.com', 'protonmail.com', 'mail.com', 'zoho.com', 'yandex.com',
    'gmx.com', 'live.com', 'me.com', 'inbox.com', 'fastmail.com'
  ];
  
  const domain = email.split('@')[1]?.toLowerCase();
  return domain ? !freeDomains.includes(domain) : false;
};

/**
 * Custom email validator for business emails
 */
export const businessEmailValidator = z.string()
  .email("Please enter a valid email address")
  .refine(isNonFreeEmail, {
    message: "Please use your business email address"
  });

/**
 * Unified contact form schema that can be used across the application
 * Fields can be made optional by using .optional() for different form contexts
 */
export const contactFormSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: businessEmailValidator,
  company: z.string().min(1, "Company name is required"),
  title: z.string().min(1, "Job title is required"),
  phone: z.string().optional(),
  committees: z.string().optional(),
  message: z.string().optional(),
});

/**
 * Helper to extract full name from first and last name
 */
export const getFullName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName}`.trim();
};

export type ContactFormValues = z.infer<typeof contactFormSchema>;
